import { CSSProperties } from "react"
import CircleLoader from "react-spinners/CircleLoader"

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  stroke: "2px",
}

function Spinner() {
  return (
    <div className="w-full h-[100vh] flex justify-center items-center">
      <CircleLoader
        color={"#38bdf8"}
        size={100}
        cssOverride={override}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}

export default Spinner
